<template>
  <v-layout 
    v-if="activities"
    wrap 
    class="activity-page"
    :style=" { width: this.width }"
  >
    <v-flex xs12 class="header">
      <span :style="{ color: color2 }">{{ titleDate }}</span><span :style="{ color: color1 }"> - {{ titleInfo }}</span>
    </v-flex>
    <v-flex
      v-bind:class="{ [display]: true }"
      v-for="(activityItem, index) of activities"
      :key="index"
      style="padding: 20px;"
    >
      <activity-item-row
        :data="activityItem"
        :color1="color1"
        :color2="color2"
        :color3="color3"
        :color4="color4"
      />
    </v-flex>
  </v-layout>
</template>

<script>
import ActivityItemRow from '../activityItemRow/Index'
export default {
  name: 'ActivityPageRow',
  components: {
    ActivityItemRow,
  },
  props: {
    titleDate: {
      type: String,
      default: null
    },
    titleInfo: {
      type: String,
      default: null
    },
    activities: {
      type: Array,
      default: null
    },
    cols: {
      type: Number,
      default: 2
    },
    color1: {
      type: String,
      default: '#02443C'
    },
    color2: {
      type: String,
      default: '#BF9D5A'
    },
    color3: {
      type: String,
      default: '#BF9D5A'
    },
    color4: {
      type: String,
      default: '#BF9D5A'
    },
    width: {
      type: Number,
      default: 1920,
    },
  },
  data: () => ({
  }),
  computed: {
    display () {
      return `xs${12/this.cols}`
    }
  }
}
</script>

<style scoped>
.activity-page {
  margin: 0;
  padding: 0 100px;
}

.header {
  padding: 90px 0;
  font-size: 50px;
  line-height: 50px;
  height: 230px;
}
</style>

